export type FaseGroup = { title: string; fases: string[] };

export const FASE_GROUPS: FaseGroup[] = [
  {
    title: "Aguardando atendimento",
    fases: ["aguardando atendimento corretor", "aguardando atendimento"],
  },
  {
    title: "Em tratativa",
    fases: [
      "em atendimento",
      "em tratativa",
      "visita agendada",
      "visita realizada",
    ],
  },
  {
    title: "Análise de crédito",
    fases: ["em análise de crédito", "análise de crédito realizada"],
  },
  {
    title: "Proposta",
    fases: ["proposta", "proposta aprovada", "proposta reprovada"],
  },
  {
    title: "Em processamento",
    fases: [
      "contrato com pendência comercial",
      "contrato com pendencia comercial",
      "contrato comunicado",
      "contrato gerado",
      "análise safi",
      "analise safi",
      "aprovado safi",
      "rejeitado safi",
      "enviado aprovação comissões",
      "enviado aprovacao comissoes",
      "aprovado comissões",
      "aprovado comissoes",
      "reprovado comissões",
      "reprovado comissoes",
      "enviado aprovação pró soluto",
      "enviado aprovacao pro soluto",
      "aprovado pró soluto",
      "aprovado pro soluto",
      "rejeitado pró soluto",
      "rejeitado pro soluto",
    ],
  },
  {
    title: "Finalizados",
    fases: [
      "fechado e ganho",
      "fechado e perdido",
      "repassado",
      "cancelado",
      "cancelada",
      "distratado",
    ],
  },
];

const normalizeFase = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

export function getFaseGroup(fase: string): FaseGroup | undefined {
  const target = normalizeFase(fase);
  if (!target) return undefined;

  // Match exato contra as fases do grupo, ou contra o próprio título do
  // grupo, isso permite que o "nome do agrupamento" (ex: "em
  // processamento") continue resolvendo pro grupo certo mesmo sem estar
  // listado em `fases` (já que não é um status real/opção do dropdown).
  const exact = FASE_GROUPS.find(
    (g) =>
      g.fases.some((f) => normalizeFase(f) === target) ||
      normalizeFase(g.title) === target,
  );
  if (exact) return exact;

  return FASE_GROUPS.find((g) =>
    g.fases.some(
      (f) =>
        target.includes(normalizeFase(f)) || normalizeFase(f).includes(target),
    ),
  );
}

const EXPANDABLE_GROUP_TITLES = [
  "Análise de crédito",
  "Em processamento",
  "Proposta",
];

// Dada uma fase (ex: vinda do clique no gráfico da Home), retorna todas as
// variações reais de fase que pertencem ao mesmo grupo — mas apenas para os
// grupos em EXPANDABLE_GROUP_TITLES ("Em processamento" e "Análise de
// crédito"). Para as demais fases, retorna só a própria fase original,
// sem agrupar com as outras do mesmo grupo.
export function getFaseGroupVariants(fase: string): string[] {
  const group = getFaseGroup(fase);
  if (group && EXPANDABLE_GROUP_TITLES.includes(group.title)) {
    return group.fases;
  }
  return [fase];
}
